<template>
  <b-row>
    <b-col tag="main" lg="12" xl="9" class="mb-4">
      <div class="bg-white shadow-sm position-relative p-5">
        <b-row>
          <b-col md="6" lg="4">
            <b-select @change="onSelectTeam">
              <b-select-option :value="null" disabled hidden />
              <b-select-option v-for="team in teams" :key="team.id" :value="team.id">
                {{team.name}}
              </b-select-option>
            </b-select>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-col lg="12" xl="3">
      <b-row>
        <b-col tag="aside" lg="6" xl="12" class="mb-4">

        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ChooseTeam',

  computed: {
    ...mapGetters([
      'teams'
    ])
  },

  methods: {
    onSelectTeam(teamId) {
      this.$router.push({ name: 'DashboardOverview', params: { teamId } })
    }
  }
}
</script>
